import { Routes, Route, Outlet } from 'react-router-dom';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import Journal from '../../components/nutrition/Journal';
import NutritionSetting from '../../components/nutrition/NutritionSetting';
import NotFoundPage from '../NotFoundPage';

const NutritionLayout = () => (
  <>
    <Header />
    <Outlet />
    <Footer />
  </>
);

const NutritionPage = () => {
  return (
    <Routes>
      <Route element={<NutritionLayout />}>
        <Route index element={<Journal />} />
        <Route path="journal" element={<Journal />} />
        <Route path="settings" element={<NutritionSetting />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default NutritionPage;
